import $ from 'jquery';
window.$ = window.jQuery = $;

const gallerySlickSettings = () => {
    return {
        'arrows': false,
        'dots': true,
        'autoplay': true,
        'autoplaySpeed': 1500,
    }
}

export function ajaxGalleryInit(){
    jQuery(document).ready(function ( $ ) {
        $('.lds-roller').hide();
        var ppp = 2; // Post per page
        var galleriesNumber = 1;
        var totalGaleries = jQuery('.totalgaleries').val();
        jQuery("#load_more_gallery").on("click", function ($) { // When btn is pressed.
            jQuery("#load_more_gallery").attr("disabled", true); // Disable the button, temp.
            // jQuery("#load_more").text("Loading..."); // Disable the button, temp.
            jQuery("#load_more_gallery").hide();
            jQuery('.lds-roller').show();
            galleriesNumber++;
            var str = '&pageNumber=' + galleriesNumber + '&ppp=' + ppp + '&action=more_gallery_ajax';
            jQuery.ajax({
                type: "POST",
                dataType: "html",
                url: the_ajax_script.ajaxurl,
                data: str,
                success: function (data) {
                    console.log(data, totalGaleries, galleriesNumber);
                    var $data = jQuery(data);
                    if ($data.length) {
                        jQuery('.gallery__box').slick('unslick');
                        jQuery(".gallery-loader").append($data);
                        jQuery("#load_more_gallery").attr("disabled", false);
                        // jQuery("#load_more").text("Load more"); // Disable the button, temp.
                        jQuery("#load_more_gallery").show();
                        jQuery('.lds-roller').hide();
                    } else {
                        jQuery("#load_more_gallery").attr("disabled", true);
                    }                
                    if (totalGaleries <= galleriesNumber) {
                        jQuery("#load_more_gallery").hide();
                    }
                    jQuery('.gallery__box').slick(gallerySlickSettings());
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    console.log(jqXHR + " :: " + textStatus + " :: " + errorThrown);
                }
            });
            return false;
        });
    });
}